import { render } from "./ClerkLogs.vue?vue&type=template&id=245b5fbe&scoped=true"
import script from "./ClerkLogs.vue?vue&type=script&lang=js"
export * from "./ClerkLogs.vue?vue&type=script&lang=js"

import "./ClerkLogs.vue?vue&type=style&index=0&id=245b5fbe&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245b5fbe"]])

export default __exports__